import Component from "@glimmer/component";
import { arg } from "glesys-controlpanel/utils/arg";
import { func, instanceOf } from "prop-types";
import PrivateNetworkSegment from "glesys-controlpanel/models/private-network-segment";
import { service } from "@ember/service";
import { task } from "ember-concurrency";

export default class EntityPrivateNetworkSegment extends Component {
  @service intl;

  @arg(instanceOf(PrivateNetworkSegment)) entity;
  @arg(func) onRoutableChange;

  get segment() {
    return this.entity;
  }

  get segmentPlatform() {
    if (this.segment.platform == "vmware") {
      return "VMware";
    }
    return "KVM";
  }

  get routingType() {
    return this.segment.routable
      ? this.intl.t("private-network.segments.type.routable")
      : this.intl.t("private-network.segments.type.isolated");
  }

  get tableData() {
    return [
      { header: this.intl.t("label.ipv4"), value: this.segment.ipv4subnet },
      { header: this.intl.t("label.ipv6"), value: this.segment.ipv6subnet },
      { header: this.intl.t("label.routing"), value: this.routingType },
      { header: this.intl.t("label.platform"), value: this.segmentPlatform },
      {
        header: this.intl.t("label.location"),
        value: this.segment.dataCenter.name,
        subValue: this.segment.dataCenter.id,
      },
    ];
  }

  loadServers = task(async () => {
    let servers = await this.segment.privateNetwork.project.get("servers");
    return servers;
  });
}
